import { render } from "./MiniModal.vue?vue&type=template&id=6a4b0252&ts=true"
import script from "./MiniModal.vue?vue&type=script&lang=ts"
export * from "./MiniModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__